module.exports = __webpack_public_path__ + "img/dc29aa3.svg";